/**
 * localStorage Utilities
 * Funciones para manejar localStorage con preservación de datos específicos
 */

/**
 * Limpia el localStorage preservando ciertos valores que deben persistir
 * entre sesiones (cookies, idioma, etc.)
 *
 * @param {Array<string>} keysToPreserve - Claves adicionales a preservar (opcional)
 */
export const clearLocalStorageExcept = (keysToPreserve = []) => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return;
  }

  // Claves que SIEMPRE deben preservarse
  const alwaysPreserve = [
    'cookie-consent', // Consentimiento de cookies
    'i18nextLng', // Idioma seleccionado (react-i18next)
    'language', // Idioma alternativo
    'selectedLanguage', // Idioma seleccionado por el usuario
  ];

  // Combinar claves a preservar
  const keysToKeep = [...alwaysPreserve, ...keysToPreserve];

  // Guardar valores a preservar
  const preserved = {};
  keysToKeep.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value !== null) {
      preserved[key] = value;
    }
  });

  // Limpiar todo el localStorage
  localStorage.clear();

  // Restaurar valores preservados
  Object.entries(preserved).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
};

/**
 * Limpia el localStorage al hacer logout
 * Preserva cookies y configuración de idioma
 */
export const clearLocalStorageOnLogout = () => {
  clearLocalStorageExcept();
};
